import React, { useEffect, useState, useContext } from "react";
import formatDatetime from "../../tools/FormatDatetime";
import formatDate from "../../tools/FormatDate";
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import APP from "../../tools/AppRoutes";
import LabelCS from "../../components/LabelCS"
import BotonCS from "../../components/BotonCS";
import TextFieldCS from "../../components/TextFieldCS";
import { Helmet } from "react-helmet-async";
import { CircularProgress } from "@mui/material";
import Context from "../Master/SessionProvider";
import { HISTORIAL } from "../../tools/ApiRoutes";

const DetalleHistorial = ({history}) => {
    const { user, selected } = useContext(Context);
    const [ loading, setLoading ] = useState(true);

    const descargar = (prop) => {
        let ruta = "";
        
        switch (prop){
            case "ccc": ruta = selected.CertificadoCamaraComer;
            break;
            case "rut": ruta = selected.Rut;
            break;
            case "rc1": ruta = selected.CartaReferencia1;
            break;
            case "rc2": ruta = selected.CartaReferencia2;
            break;
            case "irl": ruta = selected.IdentificacionRepLegal;
            break
        }
        
        const indiceInicial = ruta.lastIndexOf('\\');
        const indiceFinal = ruta.length;
        const nombre = ruta.slice(indiceInicial+1, indiceFinal);

        const data = {
            Ruta: ruta
        }

        const config = {
            method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.Token}`
                },
                body: JSON.stringify(data),
                responseType: 'blob'
        };

        fetch(HISTORIAL.DescargarArchivo, config)
        .then(response => response.blob())
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nombre;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(error => console.log(error));
    }

    const regresar = () => {
        window.scrollTo(0,0);
        history.push(APP.HISTORIAL);
    }

    useEffect(()=>{
        setLoading(false);

        //VALIDAMOS LA SESIÓN
        if (user.Usuario === '' || user.Usuario === null || user.Usuario === undefined){
            history.push(APP.INDEX);
        }

        return (() => {
            //console.log("");
        });
    }, []);

     return (<>
     <Helmet>
        <title>Detalle Historial</title>
     </Helmet>

     {
        loading ?
        <div className={'container'}>
            <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress size={100} thickness={2}></CircularProgress>
            </div>
        </div>
        :
        <div className={'container'}>
            <div className="fontNewsGothic">
                <div className="col-sm-12 col-md-12 col-lg-12">


                    {/* INICIO INFORMACIÓN GENERAL DE LA EMPRESA */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Información General de la Empresa</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Número Cliente' />   
                        </div>   
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" disabled={true} value={selected.NumeroCliente}></TextFieldCS>  
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Razón Social' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.RazonSocial}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='NIT' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <TextFieldCS name="" disabled={true} value={selected.NIT}></TextFieldCS>
                        </div>   
                        <div className="col-sm-1 col-md-1 col-lg-1">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='DV' />   
                        </div>    
                        <div className="col-sm-1 col-md-1 col-lg-1">
                            <TextFieldCS name="" disabled={true} value={selected.DV}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Dirección' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.Direccion}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Código Postal' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.CP}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Teléfono' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.Telefono}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Municipio' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.Municipio}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Departamento' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.Departamento}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Representante Legal' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.RepresentanteLegal}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Tipo Documento' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.TipoDocumento}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Número Identificación' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.NumeroIdentificacion}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Actividad Primaria' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.CodigoCIIUActividadPrimaria}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Inicio Actividad Primaria' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={formatDate(selected.FechaInicioActividad)}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '80px'}}>
                        <div className="col-sm-2 col-md-2 col-lg-2" style={{display: 'flex', height: '80px', alignItems: 'center'}}>
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Descripción Actividad Primaria' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" disabled={true} value={selected.ActividadPrincipalDes} multiline maxRows={3}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Actividad Secundaria' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.CodigoCIIUActividadSecundaria}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Inicio Actividad Secundaria' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={formatDate(selected.FechaInicioActividadSec)}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado" style={{height: '80px'}}>
                        <div className="col-sm-2 col-md-2 col-lg-2" style={{display: 'flex', height: '80px', alignItems: 'center'}}>
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Descripción Actividad Secundaria' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" disabled={true} value={selected.ActividadSecundariaDes} multiline maxRows={3}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Actividad Mayor Riesgo' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.ActividadEconomicaMayorRiesgo}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Otras Actividades' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.OtrasActividades}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Tipo Régimen' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.TipoRegimen}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Tipo Contribuyente' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.TipoContribuyente}></TextFieldCS>
                        </div>   
                    </div>
                    <br/>
                    <br/>
                    {/* FIN INFORMACIÓN GENERAL DE LA EMPRESA */}

                    {/* INICIO DATOS DEL CONTACTO COMERCIAL */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Contacto Comercial</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Nombre' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.NombreSolicitante ?? ''}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Cargo' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.CargoDeSolicitante ?? ''}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Email' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.EmailSolicitante ?? ''}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Teléfono' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.TelefonoSolicitante ?? ''}></TextFieldCS>
                        </div>   
                    </div>
                    <br/>
                    <br/>
                    {/* FIN DATOS DEL CONTACTO COMERCIAL */}

                    {/* INICIO CONTACTO ADMINISTRATIVO */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Contacto Administrativo</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Nombre' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.ContactoAdministrativoNombre ?? ''}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Email' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.ContactoAdministrativoEmail ?? ''}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Teléfono' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <TextFieldCS name="" disabled={true} value={selected.ContactoAdministrativoTelefono ?? ''}></TextFieldCS>
                        </div>   
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='' />   
                        </div>    
                        <div className="col-sm-4 col-md-4 col-lg-4">
                        </div>   
                    </div>
                    <br/>
                    <br/>
                    {/* FIN CONTACTO ADMINISTRATIVO */}

                    {/* INICIO SE ENTERÓ MEDIANTE */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Cómo Nos Conoce</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Cómo se enteró de CompuSoluciones' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" disabled={true} value={selected.DondeConocioCompuSoluciones ?? ''}></TextFieldCS>
                        </div>   
                    </div>
                    <br/>
                    <br/>
                    {/* FIN SE ENTERÓ MEDIANTE */}

                    {/* INICIO DOCUMENTOS */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <label className='tituloSeccion'>Documentos</label>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Registro Único Tributario' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        {
                                selected.Rut !== null && selected.Rut !== '' ?
                            <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('rut')}></BotonCS>
                            :<></>
                        }
                        </div> 
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Certificado Cámara Comercio' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            {
                                selected.CertificadoCamaracomer !== null && selected.CertificadoCamaraComer !== '' ?
                                <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('ccc')}></BotonCS>
                                : <></>
                            }
                        </div>                             
                    </div>
                    
                    
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Identificación Representante Legal' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        {
                            selected.IdentificacionRepLegal !== null && selected.IdentificacionRepLegal !== '' ?
                            <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('irl')}></BotonCS>
                            : <></>
                        }
                        </div>  
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Referencia Comercial 1' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        {
                            selected.CartaReferencia1 !== null && selected.CartaReferencia1 !== '' ?
                            <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('rc1')}></BotonCS>
                            : <></>
                        }
                        </div>                            
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                          
                        <div className="col-sm-4 col-md-4 col-lg-4">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Referencia Comercial 2' />   
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        {
                            selected.CartaReferencia2 !== null && selected.CartaReferencia2 !== '' ?
                            <BotonCS color='#3F9C35' title='Descargar' handleSubmit={() => descargar('rc2')}></BotonCS>
                            : <></>
                        }
                        </div>   
                        <div className="col-sm-4 col-md-4 col-lg-4">
                        </div>    
                        <div className="col-sm-2 col-md-2 col-lg-2">
                        </div> 
                    </div>
                    <br />
                    <br />
                    {/* FIN DOCUMENTOS */}

                    {/* INICIO DETALLE REVISIÓN */}
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Comentarios' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" disabled={true} value={selected.Comentarios ?? ''} multiline maxRows={3}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Revisor' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                        <TextFieldCS name="" disabled={true} value={selected.Revisor ?? ''}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Fecha Revisión' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" value={formatDatetime(selected.FechaRevision)} disabled={true}></TextFieldCS>
                        </div>   
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <LabelCS variant='subtitle1' style={{ fontWeight: 'bold' , textAlign: 'right'}} label='Códigos Responsabilidades RUT' />   
                        </div>    
                        <div className="col-sm-10 col-md-10 col-lg-10">
                            <TextFieldCS name="" value={selected.Codigos} disabled={true}></TextFieldCS>
                        </div>   
                    </div>
                    {/* FIN DETALLE REVISIÓN */}
                    <br />
                    <br />

                    <div className="col-sm-12 col-md-12 col-lg-12 contenedorCentrado">
                        <div className="col-sm-12 col-md-12 col-lg-12" style={{textAlign: '-webkit-center'}}>
                            <BotonCS color='#7F7F7F' title='Regresar' handleSubmit={regresar}></BotonCS>
                        </div>                        
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        </div>

     }
     </>)
}

export default React.memo(withRouter(DetalleHistorial));